import { apiSlice } from '../../app/api/apiSlice'

export const shippingApi = apiSlice.injectEndpoints({
  endpoints:  (builder) => ({
    listCarriers: builder.query ({
      query: () => `v1/shipping/carriers`
    }),
    listServices: builder.query ({
      query: (params) => `v1/shipping/list_services${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`
    }),
    listPackages: builder.query ({
      query: (params) => `v1/shipping/list_packages${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`
    })
  })
})

export const {
  useListCarriersQuery,
  useListServicesQuery,
  useListPackagesQuery
} = shippingApi